import React from 'react';

import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';

// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import { useAutoCreateController } from '../../../controllers/auto-create';

import { AutoCreateConfirmModal } from './confirm-modal';
import messages from './messages';

export const AutoCreateButton = () => {
	const { formatMessage } = useIntl();

	const {
		isAutoCreateEnabled,
		isAutoCreateUpdating,
		handleUpdateAutoCreation,
		isUpdateAutoCreationModalOpen,
		handleUpdateAutoCreationClick,
		handleCloseUpdateAutoCreationModal,
	} = useAutoCreateController();

	return (
		<>
			<Button isLoading={isAutoCreateUpdating} onClick={handleUpdateAutoCreationClick}>
				{formatMessage(messages.turnAutoHeartbeatButton, {
					isEnabled: isAutoCreateEnabled,
				})}
			</Button>
			<AutoCreateConfirmModal
				onConfirm={handleUpdateAutoCreation}
				onClose={handleCloseUpdateAutoCreationModal}
				isOpen={isUpdateAutoCreationModalOpen}
				isEnabled={isAutoCreateEnabled}
			/>
		</>
	);
};
